import React from "react";

import { ModuleLayout } from "@brexhq/next/src/components/pageBuilder/ModuleLayout";
import { MotionDiv } from "@brexhq/next/src/components/shared/Animation";
import { BlockRows } from "@brexhq/next/src/components/shared/BlockRows/BlockRows";
import { SanityBlockRowsProps } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowsModule";

import { Column, Grid } from "../../shared/Grid";

export const BlockRowsModule: React.FC<SanityBlockRowsProps> = ({
  data: {
    textRows,
    slideInUpViewThreshold,
    alignment = "left",
    spanAndPosition,
    moduleLayout,
  },
}) => {
  const { desktopPosition, desktopSpan, tabletPosition, tabletSpan } =
    spanAndPosition;
  const { animation } = moduleLayout;

  return (
    <ModuleLayout {...moduleLayout}>
      <MotionDiv animation={animation}>
        <Grid>
          <Column
            LRG={{ start: desktopPosition, end: `span ${desktopSpan}` }}
            MED={{ start: tabletPosition, end: `span ${tabletSpan}` }}
            SML={{ start: 1, end: "span 4" }}
          >
            <BlockRows
              alignment={alignment}
              rows={textRows.textRows}
              theme={moduleLayout.theme}
              maxWidth={textRows.maxWidth}
              slideInUpViewThreshold={slideInUpViewThreshold}
            />
          </Column>
        </Grid>
      </MotionDiv>
    </ModuleLayout>
  );
};
